import { api, unwrap, type APIResponse } from "./client";

// --- Contact-group carrier (LNP) enrichment. Mirrors app/routers/contact.py &
// app/routers/lookup.py lnp-enrich / lnp-breakdown endpoints. ---

/** Kick off background carrier enrichment for every un-enriched number in a group. */
export async function enrichGroup(groupId: number): Promise<{ job_id: number }> {
  const resp = await api.post<APIResponse<{ job_id: number }>>(
    `/contacts/groups/${groupId}/lnp-enrich`,
  );
  return unwrap(resp.data);
}

export interface LnpEnrichStatus {
  status: string; // "pending" | "processing" | "done" | ...
  total: number;
  done: number;
  error?: string | null;
}

/** Poll an enrichment job's progress. Stops mattering once status === "done". */
export async function getEnrichStatus(jobId: number): Promise<LnpEnrichStatus> {
  const resp = await api.get<APIResponse<LnpEnrichStatus>>(`/lookup/lnp-enrich/${jobId}`);
  return unwrap(resp.data);
}

export interface LnpBreakdown {
  enriched: number;
  un_enriched: number;
  by_carrier: { spid: string; carrier: string; count: number }[];
  by_line_type: { line_type: string; count: number }[];
  by_status: { status: string; count: number }[];
}

/** Carrier / line-type / status breakdown for a contact group's enriched numbers. */
export async function getBreakdown(groupId: number): Promise<LnpBreakdown> {
  const resp = await api.get<APIResponse<LnpBreakdown>>(`/contacts/groups/${groupId}/lnp-breakdown`);
  return unwrap(resp.data);
}
